<template>
  <div
    v-if="supplier && supplier.award_type && supplier.award_name"
    class="p-6 rounded"
    style="background-color: #f5f5f5"
  >
    <div class="flex sm:flex-wrap">
      <div class="flex-none pr-6 sm:w-full">
        <div class="flex items-center sm:mx-auto">
          <img width="64" height="64" :src="prizeImage" alt="ZuBlu Award" />
          <div
            class="flex-1 fs-16 font-medium lg:hidden md:hidden sm:pl-4 capitalize"
          >
            <span>
              {{ supplier.award_name }}
            </span>
            <a
              target="_blank"
              class="text-secondary fs-12 block"
              title="Learn more about all our 2023 winners"
              href="https://www.zubludiving.com/articles/zublu-insights/zublu-awards-2023"
              >Learn more about all our 2023 winners
            </a>
          </div>
        </div>
      </div>

      <div class="flex-1">
        <h4
          class="fs-20 font-medium lg:visible md:visible sm:hidden capitalize"
        >
          {{ supplier.award_name }}
        </h4>

        <p class="mt-2 sm:mt-0">
          <span class="sm:hidden">
            In recognition of your dedication to providing outstanding
            underwater experiences to ZuBlu’s valued guests.
          </span>
          <a
            target="_blank"
            class="text-secondary sm:hidden font-medium whitespace-no-wrap"
            title="Learn more about all our 2023 winners"
            href="https://www.zubludiving.com/articles/zublu-insights/zublu-awards-2023"
            >Learn more about all our 2023 winners</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["resortId"],
  data() {
    return {
      supplier: null,
    };
  },
  computed: {
    prizeImage() {
      if (!this.supplier) {
        return null;
      }

      switch (this.supplier.award_type) {
        case "gold":
          return `/img/GOLD-ZA-emblem.svg`;
        case "silver":
          return `/img/SILVER-ZA-emblem.svg`;
        default:
          return null;
      }
    },
  },
  mounted() {
    window.fetchSupplierInfo(this.resortId).then((res) => {
      this.supplier = res.supplier;
    });
  },
};
</script>
